
  import React from 'react'
  import { MDXTag } from '@mdx-js/tag'
  import { Credits } from './credits'

const layoutProps = {
  
};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props)
    this.layout = null
  }
  render() {
    const { components, ...props } = this.props

    return <MDXTag
             name="wrapper"
             
             components={components}>
<MDXTag name="h3" components={components}>{`Methodik`}</MDXTag>
<MDXTag name="p" components={components}>{`Der Fragebogen wurde von Forschern der Kalaidos Fachhochschule unter Berücksichtigung aktueller psychometrischer Standards entwickelt. Dies bezieht sich auf den Formulierungsstil der Aussagen, auf die Möglichkeit, diese abgestuft zu bewerten und auf die Zulässigkeit der anschliessenden Aussagengruppierung.`}</MDXTag>
           </MDXTag>
  }
}
MDXContent.isMDXComponent = true
  